'use client';

import Link from 'next/link';
import { useLanguage } from '@/context/LanguageContext';
import { useTranslation } from '@/translations';

export default function Footer() {
  const { language } = useLanguage();
  const t = useTranslation(language);

  const navLinks = [
    { name: t('nav.shop'), href: '/shop' },
    { name: t('nav.collections'), href: '/collections' },
    { name: t('nav.events'), href: '/events' },
    { name: t('nav.extras'), href: '/extras' },
    { name: t('nav.blog'), href: '/blog' },
  ];

  return (
    <footer className="organic" style={{ borderTop: '1px solid var(--color-divider)' }}>
      <div
        className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr] gap-8"
        style={{ padding: 'var(--space-8) clamp(20px, 4vw, 48px) var(--space-6)' }}
      >
        <div>
          <span className="nav-brand block mb-2">Buchetul Simonei</span>
          <p
            className="max-w-[40ch]"
            style={{ margin: 0, fontSize: 14, lineHeight: 1.6, color: 'color-mix(in srgb, var(--color-text) 65%, transparent)' }}
          >
            {t('footer.tagline')}
          </p>
        </div>

        <div>
          <p
            className="mb-2"
            style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--color-accent-700)' }}
          >
            {t('footer.navigation')}
          </p>
          <div className="flex flex-col gap-2" style={{ fontSize: 14 }}>
            {navLinks.map((link) => (
              <Link key={link.href} href={link.href}>{link.name}</Link>
            ))}
          </div>
        </div>

        <div>
          <p
            className="mb-2"
            style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--color-accent-700)' }}
          >
            {t('footer.contact')}
          </p>
          <div
            className="flex flex-col gap-2"
            style={{ fontSize: 14, color: 'color-mix(in srgb, var(--color-text) 70%, transparent)' }}
          >
            <span>Str. Unirii 240, Tamaseni, Neamț</span>
            <span>0769 141 250</span>
            <a href="mailto:laurasimona97@yahoo.com">laurasimona97@yahoo.com</a>
          </div>
        </div>
      </div>

      <div style={{ borderTop: '1px solid var(--color-divider)' }}>
        <div
          className="max-w-7xl mx-auto flex justify-between flex-wrap gap-2"
          style={{
            padding: 'var(--space-3) clamp(20px, 4vw, 48px)',
            fontSize: 12.5,
            color: 'color-mix(in srgb, var(--color-text) 55%, transparent)',
          }}
        >
          <span>© {new Date().getFullYear()} Buchetul Simonei. {t('footer.rights')}</span>
          <div className="flex gap-4">
            <Link href="/termeni-conditii">{t('footer.terms')}</Link>
            <Link href="/politica-cookies">{t('footer.cookiePolicy')}</Link>
            <Link href="/gdpr">{t('footer.gdpr')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
